<div *ngIf="messageService.messages.length">
  <div class="fixed-bottom">

    <div *ngFor="let message of messageService.messages">
      <div class="alert alert-{{message.type}}"
           (click)="message.noTtl = true">
        <a (click)="messageService.removeMessage(message)" class="close" data-dismiss="alert"
           aria-label="close">({{message.noTtl ? '∞' :  message.ttl + ' s'}}) &times;</a>
        {{ message.message }}
      </div>
    </div>
  </div>
</div>
